export default __webpack_public_path__ + "static/media/demo_1.f44c4ba1.png";